import TipogramABI from '../abis/Tipogram.json'
import Config from '../contractAddress/ContractAddress'


export const TIPOGRAM_CONTRACT={
    address:Config.TIPOGRAM_CONTRACT_ADDRESS,
    abi:TipogramABI
}